import styles from './ColorSwatch.module.scss'
import styled from 'styled-components'

import React from 'react'

import ColorFinder from 'Utilities/ColorFinder'

import PanelContext from 'Contexts/PanelContext'

const sizeLookup = {
  S: 0.25,
  M: 0.5,
  L: 1,
}

const ColorSwatch = ({ brand, intent, customColor, size, ...props }) => {
  if (!brand && !intent && !customColor) return null
  if ((brand || intent) && customColor) return null

  let color

  if (brand || intent) {
    const result = ColorFinder(intent, null, brand)
    color = result.color
  }

  let swatchSize
  if (size) swatchSize = sizeLookup[size]
  else return null

  const panelContextValue = {
    brand: brand,
    intent: intent,
  }

  return (
    <PanelContext.Provider value={panelContextValue}>
      <StyleColorSwatch
        className={styles.swatch}
        data-testid="colorSwatch"
        size={swatchSize}
        color={color}
        customColor={customColor?.toLowerCase()}
        {...props}
      />
    </PanelContext.Provider>
  )
}

const StyleColorSwatch = styled.span`
  height: ${(props) => props.size}rem;
  width: ${(props) => props.size}rem;
  ${(props) => (props.color ? `background-color: ${props.color};` : null)}
  ${(props) => (props.customColor ? `background-color: var(--${props.customColor});` : null)}
`

export default ColorSwatch
